import React from 'react';
import styled from 'styled-components';

import type { IPackageId } from './types';

const PackageId = ({ id, isMobile }: IPackageId) => (
  <StyledPackageId $isMobile={isMobile}>{`№ ${id}`}</StyledPackageId>
);

const StyledPackageId = styled.div<{ $isMobile: boolean }>`
  ${({ $isMobile }) =>
    $isMobile
      ? `
  font-size: 11px;
  color: #919499;
  `
      : `
  font-size 14px;
  color: #17181a;
  `}
`;

export default PackageId;
